function cleanResponse (text) {
  return text
    .replace(/\$\\rightarrow\$/g, '→')
    .replace(/\\rightarrow/g, '→')
    .replace(/\$\\leftarrow\$/g, '←')
    .replace(/\\uparrow/g, '↑')
    .replace(/\\downarrow/g, '↓')
    .replace(/\$([^$]*)\$/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^---+$/gm, '')
}

export async function sendMessage (message, history) {
  try {
    const response = await window.axios.post('chatbot/completions', {
      message,
      history
    }, {
      timeout: 60000
    })

    return {
      success: true,
      message: cleanResponse(response.data.message)
    }
  } catch (error) {
    const status = error.response && error.response.status
    const message = error.response && error.response.data && error.response.data.message

    if (status === 429) {
      return { success: false, message: message || '提問次數過於頻繁，請稍後再試。' }
    }

    if (status === 503) {
      return { success: false, message: message || 'AI 助手暫時未能回覆，請稍後再試。' }
    }

    if (status === 401) {
      return { success: false, message: '登入狀態已失效，請重新登入後再試。' }
    }

    if (status === 404) {
      return { success: false, message: 'AI 助手服務尚未設定，請聯絡管理員。' }
    }

    return { success: false, message: '網絡錯誤，請檢查網絡連線後再試。' }
  }
}
